import { compose } from "redux";
import Login from "../src/login/Login";
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { HOME, permissions } from "../src/routes";
import { accessTokenCookieName } from "../src/api/cookies";

// Server-side redirect for authenticated users
// This prevents the flash of Login page before client-side redirect
const LoginPage = compose(withAuthentication(permissions[HOME]))(
  // @ts-ignore
  Login,
);

LoginPage.getInitialProps = async (ctx: any) => {
  // Check if we're on the server with a real request (not during static export)
  if (ctx.req && ctx.req.headers) {
    // Parse cookies from request header
    const cookies = ctx.req.headers.cookie || "";
    const authToken = cookies
      .split(";")
      .find((c: string) => c.trim().startsWith(`${accessTokenCookieName}=`));

    // If user is authenticated, redirect to offers page
    if (authToken) {
      if (ctx.res) {
        ctx.res.writeHead(302, { Location: "/offers" });
        ctx.res.end();
      }
      return {};
    }
  }

  // Not authenticated, on client-side, or during static export - render login page normally
  return {};
};

export default LoginPage;
